import { APP_VERSION } from './version.js';
import type { FeedbackAppState } from '../shared/feedback.js';

export function feedbackAppState(measurement?: FeedbackAppState['measurement']): FeedbackAppState {
  return {
    version: 1,
    app_version: APP_VERSION.slice(0, 512),
    locale: document.documentElement.lang.slice(0, 512),
    viewport: { width: window.innerWidth, height: window.innerHeight },
    search: document.querySelector<HTMLInputElement>('#search-input')?.value.slice(0, 512),
    measurement,
  };
}
